import ReactRailsUJS from "react_ujs";
import ActionsDropdown from "./components/ActionsDropdown.jsx";
import ActionSuggestionModal from "./components/ActionSuggestionModal.jsx";
import AnalysisPage from "./components/AnalysisPage.jsx";
import AnalysisPageContainer from "./components/AnalysisPageContainer.jsx";
import AnalysisPieChart from "./components/AnalysisPieChart.jsx";
import AttachmentDropzone from "./components/AttachmentDropzone.jsx";
import AttachmentList from "./components/AttachmentList.jsx";
import AttachmentListContainer from "./components/AttachmentListContainer.jsx";
import AttachmentView from "./components/AttachmentView.jsx";
import BuildingGraphs from "./components/BuildingGraphs.jsx";
import ChartSelector from "./components/ChartSelector.jsx";
import CompleteActionModal from "./components/CompleteActionModal.jsx";
import DepositionAnalysis from "./components/DepositionAnalysis.jsx";
import DepositionChart from "./components/DepositionChart.jsx";
import DepositionSettings from "./components/DepositionSettings.jsx";
import FacilitiesPageAnalysis from "./components/FacilitiesPageAnalysis.jsx";
import FacilitiesSustainabilityPieChart from "./components/FacilitiesSustainabilityPieChart.jsx";
import FacilityPartList from "./components/FacilityPartList.jsx";
import FacilityPartListContainer from "./components/FacilityPartListContainer.jsx";
import FacilityPartModal from "./components/FacilityPartModal.jsx";
import KPIBox from "./components/KPIBox.jsx";
import ListContainer from "./components/ListContainer.jsx";
import ListHeaderCell from "./components/ListHeaderCell.jsx";
import ListItemsPerPageSelection from "./components/ListItemsPerPageSelection.jsx";
import ListSettings from "./components/ListSettings.jsx";
import Loader from "./components/Loader.jsx";
import LoadWrapper from "./components/LoadWrapper.jsx";
import MagicLinkGenerator from "./components/MagicLinkGenerator.jsx";
import MaintenancePlanSelect from "./components/MaintenancePlanSelect.jsx";
import Modal from "./components/Modal.jsx";
import PaginationControls from "./components/PaginationControls.jsx";
import PaginationInfo from "./components/PaginationInfo.jsx";
import PaginationRow from "./components/PaginationRow.jsx";
import PieChart from "./components/PieChart.jsx";
import RailsFilterMultiSelect from "./components/RailsFilterMultiSelect.jsx";
import RailsMaintenancePlanSelect from "./components/RailsMaintenancePlanSelect.jsx";
import RailsStatusPicker from "./components/RailsStatusPicker.jsx";
import RichTextEditor from "./components/RichTextEditor.jsx";
import StatusPicker from "./components/StatusPicker.jsx";
import StatusPieChart from "./components/StatusPieChart.jsx";
import SuggestionList from "./components/SuggestionList.jsx";
import SuggestionListContainer from "./components/SuggestionListContainer.jsx";
import SustainabilityPage from "./components/SustainabilityPage.jsx";
import TimeBarChart from "./components/TimeBarChart.jsx";
import Tooltip from "./components/Tooltip.jsx";
import UIBox from "./components/UIBox.jsx";
import ClimateRisksBarChart from "./components/ClimateRisksBarChart.jsx";

// Add each component to window
window.ActionsDropdown = ActionsDropdown;
window.ActionSuggestionModal = ActionSuggestionModal;
window.AnalysisPage = AnalysisPage;
window.AnalysisPageContainer = AnalysisPageContainer;
window.AnalysisPieChart = AnalysisPieChart;
window.AttachmentDropzone = AttachmentDropzone;
window.AttachmentList = AttachmentList;
window.AttachmentListContainer = AttachmentListContainer;
window.AttachmentView = AttachmentView;
window.BuildingGraphs = BuildingGraphs;
window.ChartSelector = ChartSelector;
window.CompleteActionModal = CompleteActionModal;
window.DepositionAnalysis = DepositionAnalysis;
window.DepositionChart = DepositionChart;
window.DepositionSettings = DepositionSettings;
window.FacilitiesPageAnalysis = FacilitiesPageAnalysis;
window.FacilitiesSustainabilityPieChart = FacilitiesSustainabilityPieChart;
window.FacilityPartList = FacilityPartList;
window.FacilityPartListContainer = FacilityPartListContainer;
window.FacilityPartModal = FacilityPartModal;
window.KPIBox = KPIBox;
window.ListContainer = ListContainer;
window.ListHeaderCell = ListHeaderCell;
window.ListItemsPerPageSelection = ListItemsPerPageSelection;
window.ListSettings = ListSettings;
window.Loader = Loader;
window.LoadWrapper = LoadWrapper;
window.MagicLinkGenerator = MagicLinkGenerator;
window.MaintenancePlanSelect = MaintenancePlanSelect;
window.Modal = Modal;
window.PaginationControls = PaginationControls;
window.PaginationInfo = PaginationInfo;
window.PaginationRow = PaginationRow;
window.PieChart = PieChart;
window.RailsFilterMultiSelect = RailsFilterMultiSelect;
window.RailsMaintenancePlanSelect = RailsMaintenancePlanSelect;
window.RailsStatusPicker = RailsStatusPicker;
window.RichTextEditor = RichTextEditor;
window.StatusPicker = StatusPicker;
window.StatusPieChart = StatusPieChart;
window.SuggestionList = SuggestionList;
window.SuggestionListContainer = SuggestionListContainer;
window.SustainabilityPage = SustainabilityPage;
window.TimeBarChart = TimeBarChart;
window.Tooltip = Tooltip;
window.UIBox = UIBox;
window.ClimateRisksBarChart = ClimateRisksBarChart;

ReactRailsUJS._firstTurboLoadSkipped = false;
ReactRailsUJS.handleEvent("turbo:load", () => {
  if (ReactRailsUJS._firstTurboLoadSkipped) {
    ReactRailsUJS.handleMount();
  }
  ReactRailsUJS._firstTurboLoadSkipped = true;
});
ReactRailsUJS.handleEvent("turbo:before-render", () => {
  ReactRailsUJS.handleUnmount();
});
ReactRailsUJS.handleEvent("turbo:frame-load", () => {
  ReactRailsUJS.handleMount();
});
ReactRailsUJS.handleEvent("turbo:before-stream-render", (event) => {
  const targets = event.target?.targetElements || [];

  targets.forEach((el) => ReactRailsUJS.unmountComponents(el));
  requestAnimationFrame(() => {
    // TODO: Investigate why we need the timeout here.
    // But it's better to update ReactUJS to ReactOnRails before that.
    // If we're lucky ReactOnRails doesn't have this issue.
    setTimeout(() => {
      ReactRailsUJS.handleMount();
    });
  });
});
